import { OkrPendingKeyResultsState } from './interfaces';

export const okrPendingKeyResultsInitialState: OkrPendingKeyResultsState = {
  items: [],
  loading: false,
  init: false,
};

export const storeName = 'okrPendingKeyResults';
